export default "__VITE_ASSET__bc041934__"